import React from "react";
import { css } from "emotion";
import { boxStyles } from "../../styles/theme";
import MenuButton from "../header/MenuButton";
import BackButton from "../BackButton";

const SettingsTopRow = ({ backRoute }) => {
  return (
    <div className={container}>
      <BackButton route={backRoute || "settings"} />
      <MenuButton />
    </div>
  );
};

export default SettingsTopRow;

const container = css`
  padding: ${boxStyles.standardPadding};
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
